import React from 'react';
import { useTranslation } from 'react-i18next';
import ChatSendIcon from 'components/atoms/icons/chatSendIcon';
import BaseButton from 'components/atoms/baseButton';
import BaseTextArea from 'components/atoms/base-textarea';

import s from './styles.module.scss';

interface IChatInputProps {
  value: string;
  setValue: (data: string) => void;
  onSubmit: () => void;
  onSubmitReply: () => void;
  isClosed: boolean;
  loading: boolean;
  id: string;
  disabled?: boolean;
}

const ChatInput: React.FC<IChatInputProps> = (props) => {
  const {
    value,
    setValue,
    onSubmit,
    onSubmitReply,
    isClosed,
    loading,
    id,
    disabled = false,
  } = props;

  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <BaseTextArea
        id={id}
        value={value}
        placeholder={`${t('smsDashboard.type_message')}...`}
        onChange={(message: string) => setValue(message)}
        disabled={loading || disabled}
        rows={1}
        maxRows={7}
        plaintext={false}
        style={{
          padding: '8.5px 57px 8.5px 12px',
          lineHeight: '15.6px',
          maxHeight: '200px',
        }}
        onKeyDown={(e) => {
          if (
            (e.key === 'Enter' || e.key === 'Return') &&
            (e.ctrlKey || e.metaKey)
          ) {
            e.preventDefault();
            if (!value.trim() || loading) {
              return;
            }
            onSubmit();
          }
        }}
        autoFocus
      />
      <div className={s['send-button']}>
        <BaseButton
          type="secondary"
          disabled={value.trim() === '' || disabled}
          loading={loading}
          onClick={onSubmit}
          icon={<ChatSendIcon />}
        />
      </div>
      <BaseButton
        type="secondary"
        label={t('labels.replyClose')}
        disabled={value.trim() === '' || disabled || isClosed || loading}
        className={s.reply}
        onClick={onSubmitReply}
      />
    </div>
  );
};

export default ChatInput;
